import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Card,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  FormControl,
  IconButton,
  MenuItem,
  Paper,
  Select,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  styled,
  tableCellClasses,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import RightArrowOpen from "../../../icons/RightArrowOpen.svg";
import Paginator from "../../../toolkit/Paginator";
import axios from "../../../utils/fvAxios";
import BaseUrl from "../../../utils/base-uri.json";
import { isArray } from "lodash";
import _ from "lodash";
import LoadingSpinner from "../../../toolkit/LoadingSpinner";
import ErrorAlert from "../../../toolkit/ErrorAlert";
import {
  KeyboardArrowDown,
  KeyboardArrowUp,
  UnfoldMore,
} from "@mui/icons-material";
import debounce from 'lodash/debounce';

const queryUrl = BaseUrl.baseUrl + BaseUrl.OnsiteOffsite.GetOffsiteEmployees;
const pageSize = 10;

const toQueryString = (obj) => {
  return "?".concat(
    Object.keys(obj)
      .map((e) => {
        if (isArray(obj[e])) {
          var d = obj[e]?.map(
            (r, idx) => `${e}[${idx}]=${encodeURIComponent(r)}`
          );
          return d.join("&");
        }
        return obj[e]
          ? `${encodeURIComponent(e)}=${encodeURIComponent(obj[e])}`
          : null;
      })
      .filter((e) => !!e)
      .join("&")
  );
};

const getUrl = (url, data) => `${url}${toQueryString(data)}`;

export default function ClientEmployees({ clientId, hasBadgePermission, hasPermission }) {
  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: theme.palette.action.hover,
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14,
    },
    // hide last border
    "&:last-child td, &:last-child th": {
      border: 0,
      marginBottom: "20px",
    },
  }));

  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: 50 * 5 + 8,
        width: 200,
      },
    },
  };

  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));

  const [open, setOpen] = useState(false);
  const [pageCount, setPageCount] = useState(1);
  const [pageNumber, setPageNumber] = useState(1);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [searchValue, setSearchValue] = useState("");
  const [Searchdebounce, setSearchdebounce] = useState("");
  const [refresh, setRefresh] = useState(true);
  const [clientEmployees, setClientEmployees] = useState(null);
  const [tagNumber, setTagNumber] = useState();
  const [badgeNumber, setBadgeNumber] = useState();
  const [isTagDisabled, setIsTagDisabled] = useState(false);
  const [isBadgeDisabled, setIsBadgeDisabled] = useState(false);
  const [departmentId, setDepartmentId] = useState(0);
  const [departments, setDepartments] = useState(null);
  const [selectedVendor, setSelectedVendor] = useState({
    vendorId: null,
    empId: null,
  });
  const [orderBy, setOrderBy] = useState({
    sortingColumn: "Name",
    sortAscending: true,
  });

  const [paramsState, setParamsState] = useState({
    pageSize: 10,
    pageNumber: pageNumber,
    departmentId: departmentId === 0 ? null : departmentId,
    userType: 2,
    search: searchValue,
    orderBy: orderBy.sortingColumn,
    sortOrder: orderBy.sortAscending ? "ASC" : "DESC",
  });

  const handleClickOpen = (vendorId, empId, tagNumber, badgeNumber) => {
    // if (tagNumber) {
    //   setIsTagDisabled(true);
    //   setTagNumber(tagNumber);
    // }
    // if (badgeNumber) {
    //   setIsBadgeDisabled(true);
    //   setBadgeNumber(badgeNumber);
    // }
    setSelectedVendor({ vendorId, empId });
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setSelectedVendor({ vendorId: null, empId: null });
    setTagNumber(undefined);
    setIsTagDisabled(false);
    setBadgeNumber(undefined);
    setIsBadgeDisabled(false);
  };

  const chekcinEmployee = (ID, VID, EID) => {
    const { vendorId, empId } = selectedVendor;
    const data = {
      vendorEmployeeID: ID == 1 ? EID : empId,
      vendorID: ID == 1 ? VID : vendorId,
      departmentId: departmentId === 0 ? null : departmentId,
      tagNumber: tagNumber,
      badgeNumber: badgeNumber,
      userType: 2,
    };
    axios
      .post(BaseUrl.baseUrl + BaseUrl.OnsiteOffsite.CheckinUser, data)
      .then((resp) => {
        if (resp?.data?.data === "Success") {
          setRefresh(true);
        }
      }).catch((err) => setError(err))
      .finally(() => {
        handleClose();
      });
  };

  useEffect(() => {
    axios
      .get(
        BaseUrl.baseUrl +
        BaseUrl.Users.GetClientDepartments +
        "clientId=" +
        clientId
      )
      .then((resp) => {
        if (resp?.data?.responseMessage === "Success") {
          setDepartments(resp?.data?.data);
          console.log(resp?.data?.data, "departments");
          setDepartmentId(0);
        }
      })
      .catch((err) => console.log(err));
  }, []);

  const changeDepartment = (value) => {
    setDepartmentId(value);
    setParamsState((prev) => ({
      ...prev,
      departmentId: value === 0 ? null : value,
      pageNumber: 1,
    }));
    setRefresh(true);
  };

  useEffect(() => {
    if (refresh) {
      if (searchValue === Searchdebounce) {
        setLoading(true);
        const url = getUrl(queryUrl, { ...paramsState });
        axios
          .get(url)
          .then((res) => {
            if (res?.data?.responseMessage === "Success") {
              const clientEmployees = res?.data?.data;
              setPageCount(Math.ceil((res?.data?.count || pageSize) / pageSize));
              setClientEmployees(clientEmployees);
            } else {
              setError(res?.data?.responseMessage);
            }
          })
          .catch((err) => setError(err))
          .finally(() => {
            setLoading(false);
            setRefresh(false);
          });
      }
    }
  }, [paramsState, refresh, searchValue, Searchdebounce]);

  // const debouncedSearch = _.debounce((value) => {
  //   setParamsState((prev) => ({
  //     ...prev,
  //     search: value,
  //     pageNumber: 1,
  //   }));
  //   setRefresh(true);
  // }, 1000);

  // const changeSearchValue = (value) => {
  //   if (searchValue !== value) {
  //     setSearchValue(value);
  //     debouncedSearch(value);
  //   }
  // };
  const delayedSearch = debounce((value) => {
    setSearchdebounce(value)
    setParamsState((prev) => ({
      ...prev,
      search: value,
      pageNumber: 1,
    }));
    setRefresh(true);
  }, 2000);

  const changeSearchValue = (e) => {
    const { value } = e.target;
    setSearchValue(value);
    delayedSearch(value);
  };


  const changeTagNumber = (value) => {
    const numericInput = value.replace(/[^0-9]/g, "");
    if (numericInput.length <= 4) setTagNumber(numericInput);
    else setTagNumber(numericInput.substring(0, 4));
  };

  const changeBadgeNumber = (value) => {
    const numericInput = value.replace(/[^0-9]/g, "");
    if (numericInput.length <= 4) setBadgeNumber(numericInput);
    else setBadgeNumber(numericInput.substring(0, 4));
  };

  const setPage = (pageNumber) => {
    if (pageNumber > 0) {
      setPageNumber(pageNumber);
      setParamsState((prev) => ({ ...prev, pageNumber }));
      setRefresh(true);
    }
  };

  const sortTable = (sortingColumn) => {
    if (orderBy.sortingColumn === sortingColumn) {
      setOrderBy((prev) => ({
        ...prev,
        sortAscending: !orderBy.sortAscending,
      }));
    } else {
      setOrderBy({
        sortingColumn,
        sortAscending: true,
      });
    }
  };

  useEffect(() => {
    setParamsState((prev) => ({
      ...prev,
      orderBy: orderBy.sortingColumn,
      sortOrder: orderBy.sortAscending ? "ASC" : "DESC",
    }));
    setRefresh(true);
  }, [orderBy]);

  return (
    <>
      <Dialog fullScreen={fullScreen} open={open} onClose={handleClose}>
        <DialogContent sx={{ padding: "48px 48px" }}>
          <DialogTitle
            sx={{
              textAlign: "center",
              fontWeight: 500,
              fontSize: 20,
            }}
          ></DialogTitle>
          <DialogActions>
            <div>
              <div>
                {hasPermission && <div>
                  <span style={{ color: "#3E4A62" }}>Tag Number </span>
                  <br />
                  <TextField
                    placeholder="Tag Number"
                    sx={{
                      "& legend": { display: "none" },
                      "& fieldset": { top: 0 },
                      fontFamily: "Arial, FontAwesome",
                    }}
                    variant="outlined"
                    size="small"
                    value={tagNumber}
                    disabled={isTagDisabled}
                    onChange={(e) => changeTagNumber(e.target.value)}
                  />
                </div>}

                {hasBadgePermission && (
                  <div className="mt-3">
                    <span style={{ color: "#3E4A62" }}>Badge Number</span>
                    <br />

                    <TextField
                      placeholder="Badge Number"
                      sx={{
                        "& legend": { display: "none" },
                        "& fieldset": { top: 0 },
                        fontFamily: "Arial, FontAwesome",
                      }}
                      variant="outlined"
                      size="small"
                      value={badgeNumber}
                      disabled={isBadgeDisabled}
                      onChange={(e) => changeBadgeNumber(e.target.value)}
                    />
                  </div>
                )}
              </div>

              <DialogActions>
                <div className="login-help__buttonContainer mt-4">
                  <Button
                    variant="contained"
                    className="login-help-button-cancel mx-2"
                    onClick={handleClose}
                  >
                    Cancel
                  </Button>
                  <Button
                    variant="contained"
                    className="login-button-request mx-2"
                    onClick={chekcinEmployee}
                  >
                    Submit
                  </Button>
                </div>
              </DialogActions>
            </div>
          </DialogActions>
        </DialogContent>
      </Dialog>

      <Card>
        <div style={{ marginLeft: "10px", padding: "10px", color: "red" }}>
          This tab is for checking company employees onsite only. To check an
          employee onsite, select the “Onsite” radio button to the right of the
          name, after which the name will disappear.
        </div>
        <Divider
          sx={{
            marginTop: 2,
            marginBottom: 2,
            backgroundColor: "#667085;",
            height: "2px",
          }}
        />
        <div
          style={{
            marginLeft: "15px",
            marginBottom: "15px",
            marginTop: "20px",
          }}
        >
          <Stack spacing={2} direction="row">
            <TextField
              placeholder="Search"
              value={searchValue}
              onChange={changeSearchValue}
              sx={{
                "& legend": { display: "none" },
                "& fieldset": { top: 0 },
                fontFamily: "Arial, FontAwesome",
              }}
              variant="outlined"
              size="small"
            />
            {/* <div style={{ marginLeft: "Auto" }}>
              <FormControl sx={{ m: 1, width: 200 }}>
                <Select
                  labelId="demo-multiple-name-label"
                  id="demo-multiple-name"
                  value={departmentId}
                  size="small"
                  onChange={(e) => changeDepartment(e.target.value)}
                  MenuProps={MenuProps}
                >
                  {departments && departments[0]?.value != 0 && (
                    <MenuItem key={0} value={0}>
                      Select Department
                    </MenuItem>
                  )}
                  {departments?.map((department) => (
                    <MenuItem key={department.value} value={department.value}>
                      {department.key}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </div> */}
          </Stack>
        </div>

        <Box sx={{ backgroundColor: "#f8f9fa" }}>
          {loading ? (
            <LoadingSpinner />
          ) : clientEmployees?.length > 0 ? (
            <TableContainer component={Paper} sx={{ borderBottom: 0 }}>
              <Table aria-label="customized table">
                <TableHead>
                  <TableRow>
                    <StyledTableCell onClick={() => sortTable("Name")}>
                      <span style={{ color: "#667085", fontSize: "16px" }}>
                        Employee Name
                      </span>
                      <IconButton>
                        {orderBy.sortingColumn === "Name" ? (
                          orderBy.sortAscending ? (
                            <KeyboardArrowUp />
                          ) : (
                            <KeyboardArrowDown />
                          )
                        ) : (
                          <UnfoldMore />
                        )}
                      </IconButton>
                    </StyledTableCell>
                    {/* <StyledTableCell
                      onClick={() => sortTable("DepartmentName")}
                    >
                      <span style={{ color: "#667085", fontSize: "16px" }}>
                        Department Name
                      </span>
                      <IconButton>
                        {orderBy.sortingColumn === "DepartmentName" ? (
                          orderBy.sortAscending ? (
                            <KeyboardArrowUp />
                          ) : (
                            <KeyboardArrowDown />
                          )
                        ) : (
                          <UnfoldMore />
                        )}
                      </IconButton>
                    </StyledTableCell> */}
                        <StyledTableCell>
                      <span style={{ color: "#667085", fontSize: "16px" }}>
                      &nbsp;
                      </span>
                    </StyledTableCell>
                    <StyledTableCell>
                      <span style={{ color: "#667085", fontSize: "16px" }}>
                        Onsite
                      </span>
                    </StyledTableCell>
                  </TableRow>
                </TableHead>

                {clientEmployees?.map((r, i) => (
                  <TableBody key={i}>
                    <TableRow key={i}>
                      <StyledTableCell sx={{ width: "34%" }}>
                        {r.lastName + ", " + r.firstName}
                      </StyledTableCell>

                      <StyledTableCell sx={{ width: "32%" }}>
                        <span>{r.departmentName}</span>
                      </StyledTableCell>

                      <StyledTableCell sx={{ width: "20%" }}>
                        <IconButton
                          aria-label="OpenArrow"
                          onClick={() => {
                            hasPermission == false && hasBadgePermission == false
                              ?
                              chekcinEmployee(
                                1,
                                r.vendorID,
                                r.employeeID
                              )
                              :
                              handleClickOpen(
                                r.vendorID,
                                r.employeeID,
                                r.oldTagId === 0 ? undefined : r.oldTagId,
                                r.oldBadgeId === 0 ? undefined : r.oldBadgeId
                              )
                          }
                          }
                        >
                          <span>
                            {" "}
                            <img
                              src={RightArrowOpen}
                              alt="OpenArrow"
                              style={{ width: "20px" }}
                            />{" "}
                            <span
                              style={{
                                color: "#2A93DB",
                                fontSize: "initial",
                              }}
                            >
                              Onsite
                            </span>{" "}
                          </span>
                        </IconButton>
                      </StyledTableCell>
                    </TableRow>
                  </TableBody>
                ))}
              </Table>
            </TableContainer>
          ) : error ? (
            <ErrorAlert message={error} />
          ) : (
            <ErrorAlert severity="warning" message={"No results found!"} />
          )}
        </Box>
      </Card>

      {!loading && clientEmployees?.length > 0 && (
        <Paginator
          count={pageCount}
          page={Number(pageNumber)}
          margin="18px 0px"
          onChange={setPage}
        />
      )}
    </>
  );
}
